var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgReport1(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 26,
    viewBox: "0 0 32 26",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30.5547 0.265625H1.30469C0.682422 0.265625 0.179688 0.768359 0.179688 1.39062V23.8906C0.179688 24.5129 0.682422 25.0156 1.30469 25.0156H30.5547C31.177 25.0156 31.6797 24.5129 31.6797 23.8906V1.39062C31.6797 0.768359 31.177 0.265625 30.5547 0.265625ZM27.3098 7.1L16.8684 17.5484C16.8155 17.6008 16.7441 17.6301 16.6697 17.6301C16.5953 17.6301 16.524 17.6008 16.4711 17.5484L12.4457 13.523L6.38125 19.591C6.32839 19.6434 6.25701 19.6727 6.18262 19.6727C6.10823 19.6727 6.03684 19.6434 5.98398 19.591L4.69023 18.2973C4.63789 18.2444 4.60853 18.173 4.60853 18.0986C4.60853 18.0242 4.63789 17.9529 4.69023 17.9L12.2453 10.3414C12.3543 10.2324 12.5336 10.2324 12.6426 10.3414L16.668 14.3633L25.6152 5.4125C25.7242 5.30352 25.9035 5.30352 26.0125 5.4125L27.3062 6.70625C27.4187 6.81172 27.4188 6.99102 27.3098 7.1Z",
    fill: "#1A5785"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgReport1);
export default __webpack_public_path__ + "static/media/report1.87e43f1053bf90596d88a2f064a01f80.svg";
export { ForwardRef as ReactComponent };